import _ from 'lodash';

const processGuidelines = async ({
  receivedGuidelines,
  initialBoard,
  filter,
  setFilterTotal,
  getGuidelineType,
}) => {
  if (!receivedGuidelines) return initialBoard;

  const guidelineState = _.cloneDeep(initialBoard);

  const getBoardIndex = (index) => {
    return guidelineState.findIndex((column) => column.title === initialBoard[index]?.title);
  };

  const sortedGuideline = Object.entries(receivedGuidelines)
    .sort((a, b) => a[1]['position'] - b[1]['position'])
    .filter(([, guidelineValue]) => {
      if (!filter) return true;
      let totalFilters = 0;
      let assignedBool = 1;
      let createDateBool = 1;
      let productionYearBool = 1;
      let productionMonthBool = 1;
      let typeBool = 1;
      let searchBool = 1;

      if (!_.isEmpty(filter.assignedTo)) {
        assignedBool = 0;
        filter.assignedTo.forEach(({ value }) => {
          totalFilters++;
          if (guidelineValue.assignedTo?.includes(value)) assignedBool++;
        });
      }

      if (!_.isEmpty(filter.type)) {
        typeBool = 0;
        filter.type.forEach(({ value }) => {
          totalFilters++;
          if (getGuidelineType(guidelineValue.type) === getGuidelineType(value)) typeBool++;
        });
      }

      if (filter.endDate) {
        totalFilters++;
        createDateBool = 0;
        const cardsCreatedAt = new Date(guidelineValue.createdAt);
        const filterStartDate = new Date(filter.startDate.getTime());
        const filterEndDate = new Date(filter.endDate.getTime());

        cardsCreatedAt.setHours(0, 0, 0, 0);
        filterStartDate.setHours(0, 0, 0, 0);
        filterEndDate.setHours(0, 0, 0, 0);

        if (cardsCreatedAt >= filterStartDate && cardsCreatedAt <= filterEndDate) {
          createDateBool++;
        }
      }

      if (!_.isEmpty(filter.productionYear)) {
        productionYearBool = 0;

        if (guidelineValue.productionDate) {
          const productionYear = guidelineValue.productionDate.year;

          const filterProductionYear = filter.productionYear.filter((year) => {
            totalFilters++;
            return year.value === productionYear;
          });

          if (filterProductionYear.length > 0) productionYearBool++;
        }
      }

      if (!_.isEmpty(filter.productionMonth)) {
        productionMonthBool = 0;

        if (guidelineValue.productionDate) {
          const productionMonth = guidelineValue.productionDate.month;

          const filterProductionMonth = filter.productionMonth.filter((month) => {
            totalFilters++;
            return month.value === productionMonth;
          });

          if (filterProductionMonth.length > 0) productionMonthBool++;
        }
      }

      if (filter.search) {
        searchBool = 0;
        totalFilters++;

        const normalizedSearch = filter.search
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();

        const normalizedPrimaryKeyword = guidelineValue?.primaryKeyword
          ? guidelineValue.primaryKeyword
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
          : '';

        if (normalizedPrimaryKeyword.includes(normalizedSearch)) searchBool++;
      }

      setFilterTotal(totalFilters);

      return (
        assignedBool &&
        createDateBool &&
        productionYearBool &&
        productionMonthBool &&
        typeBool &&
        searchBool
      );
    })
    .reduce(
      (sortedObj, [key, value]) => ({
        ...sortedObj,
        [key]: value,
      }),
      {},
    );

  for (const [, value] of Object.entries(sortedGuideline)) {
    switch (value.column) {
      case 'BACKLOG':
        guidelineState[getBoardIndex(0)].cards?.push(value);
        break;
      case 'GUIDELINE_APPROVAL':
        guidelineState[getBoardIndex(1)].cards?.push(value);
        break;
      case 'CONTENT_STRUCTURE':
        guidelineState[getBoardIndex(2)].cards?.push(value);
        break;
      case 'PRE_REVIEW':
        guidelineState[getBoardIndex(3)].cards?.push(value);
        break;
      case 'CONTENT_REVIEW':
        guidelineState[getBoardIndex(4)].cards?.push(value);
        break;
      case 'INTERNAL_APPROVAL':
        guidelineState[getBoardIndex(5)].cards?.push(value);
        break;
      case 'CONTENT_APPROVAL':
        guidelineState[getBoardIndex(6)].cards?.push(value);
        break;
      case 'APPROVED':
        guidelineState[getBoardIndex(7)].cards?.push(value);
        break;
      case 'PUBLISHED':
        guidelineState[getBoardIndex(8)].cards?.push(value);
        break;
    }
  }

  guidelineState.forEach((column) => {
    column.cards.sort((a, b) => a.position - b.position);
  });

  return guidelineState;
};

export { processGuidelines };
